export default __webpack_public_path__ + "static/media/ic-avatar.043c4220.svg";